// extracted by mini-css-extract-plugin
export default {"toTop":"index_toTop_1e-QC","toHome":"index_toHome_krUwe"};